import React, { createContext, useContext, useState } from 'react';
import translations, { Lang, Translations } from '../lib/translations';

interface LanguageContextType {
  language: Lang;
  setLanguage: (l: Lang) => void;
  t: Translations;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState<Lang>(() => {
    return (localStorage.getItem('language') as Lang) || 'pt-BR';
  });

  const handleSetLanguage = (l: Lang) => {
    setLanguage(l);
    localStorage.setItem('language', l);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage: handleSetLanguage, t: translations[language] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};
